<!--
* @Author : ShaJiaJing
* @Date :  2019/5/31
* @Version : 1.0
* @Content : 趋势图
-->
<template>
  <a-row class="trends" :gutter="24">
    <a-col class="mb24" :xs="24" :lg="12">
      <div class="trends-item">
        <header>
          <h5>{{ $t('dashboard.fifth.title') }}</h5>
          <div class="conditions">
            <a-radio-group :value="timeType" buttonStyle="solid" @change="getTaskTimeTrends">
              <a-radio-button :key="index" :value="item.value" v-for="(item, index) in timeTypeOptions">{{ $t(`dashboard.common.${item.locale}`) }}</a-radio-button>
            </a-radio-group>
          </div>
        </header>
        <div class="trends-chart">
          <v-chart
            height="254"
            :data="timeTrends"
            :forceFit="true"
            :padding="['auto', 'auto', '50', '30']"
            :scale="scale"
          >
            <v-tooltip />
            <v-axis dataKey="x" :label="label" :tickLine="tickLine" />
            <v-bar position="x*任务数"/>
          </v-chart>
        </div>
      </div>
    </a-col>
    <a-col class="mb24" :xs="24" :lg="12">
      <div class="trends-item">
        <header>
          <h5>{{ $t('dashboard.sixth.title') }}</h5>
          <div class="conditions">
            <a-radio-group :value="timeType2" buttonStyle="solid" @change="getTaskFailTrends">
              <a-radio-button :key="index" :value="item.value" v-for="(item, index) in timeTypeOptions">{{ $t(`dashboard.common.${item.locale}`) }}</a-radio-button>
            </a-radio-group>
          </div>
        </header>
        <div class="trends-chart">
          <v-chart
            height="254"
            :data="failTrends"
            :forceFit="true"
            :padding="['auto', 'auto', '50', '30']"
            :scale="scale"
          >
            <v-tooltip />
            <v-axis dataKey="x" :label="label" :tickLine="tickLine" />
            <v-bar position="x*任务失败数"/>
          </v-chart>
        </div>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import { getTaskTimeTrends, getTaskFailTrends } from '@api/dashboard'
const timeTypeOptions = [
  {
    value: 1,
    label: '今天',
    locale: 'today'
  },
  {
    value: 2,
    label: '昨天',
    locale: 'yesterday'
  },
  {
    value: 3,
    label: '上周',
    locale: 'lastWeek'
  },
  {
    value: 4,
    label: '过去30天',
    locale: 'lastThirty'
  }
]

const barConfig = {
  tickLine: {
    length: '0',
    alignWithLabel: false
  },
  line: {
    length: 0
  },
  label: {
    textStyle: {
      fill: '#999999',
      fontSize: 14
    }
  },
  scale: [{
    dataKey: 'x'
  }]
}
export default {
  components: {},
  data () {
    return {
      timeTypeOptions,
      timeType: 1,
      timeType2: 1,
      timeTrends: {},
      failTrends: {},
      ...barConfig
    }
  },
  created () {
    this.getTaskTimeTrends()
    this.getTaskFailTrends()
  },
  mounted () {
  },
  computed: {},
  methods: {
    getTaskTimeTrends (e) {
      if (e) {
        this.timeType = e.target.value
      }
      getTaskTimeTrends(this.timeType)
        .then(({ xAxis, series }) => {
          const res = []
          xAxis.map((row, index) => {
            res.push({
              x: row,
              '任务数': series[index]
            })
          })
          this.timeTrends = res
        })
    },
    getTaskFailTrends (e) {
      if (e) {
        this.timeType2 = e.target.value
      }
      getTaskFailTrends(this.timeType2)
        .then(result => {
          if (result) {
            const res = []
            const { series, xAxis } = result
            xAxis.map((row, index) => {
              res.push({
                x: row,
                '任务失败数': series[index]
              })
            })
            this.failTrends = res
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.trends{
  .trends-item{
    background-color: #fff;
  }
  header{
    display: flex;
    justify-content: space-between;
    height: 48px;
    line-height: 48px;
    align-items: center;
    padding: 0 24px;
    border-bottom: 2px solid #d9d9d9;
    h5{
      font-size: 16px;
      color: #111111;
      font-weight: normal;
    }
    .conditions{
    }
  }
  .trends-chart{
    padding: 30px 24px 10px;
  }
}
</style>
